var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"v-resume-icon-button",class:_vm.className},[_c('svg',[_c('use',{attrs:{"xlink:href":`frontend/src/components_new/b2c/vresume-icon-button/icons.svg#${_vm.iconName}`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }